<template>
  <div class="info-row-button" @click="click">
    <img v-if="logo != null" class="logo" :src="logo" alt="">
    <div v-else class="vendor">
      <img class="icon" :src="icon" alt="">
      <div class="method">{{ method }}</div>
    </div>
    <div class="processing">{{ processing }}</div>
    <div class="fee">{{ fee }}</div>
    <div class="arrow-right"></div>
  </div>
</template>

<script>
export default {
  name: "InfoRowButton",
  props: [
    'icon',
    'method',
    'logo',
    'processing',
    'fee'
  ],
  methods: {
    click() {
      this.$emit('click')
    }
  }
}
</script>
